<template>
  <div style="display: flex; justify-content: center; align-items: center;">
    <span 
      @mouseleave="stopLongPress"
      @click="previous()"
      @mousedown="buttonMousedown('minus')"
      @mouseup="buttonMouseup()"
    >
      <BaseButtonIcon
        id="less"
        :classState="renderClass('prev')"
        :svgPath="require('@/lib/tui/assets/common/increment/minus_increment.svg')"

        style="margin-right: 0.5vw"
      >
      </BaseButtonIcon>
    </span>

    <span>
      <BaseInputText
        class="small inputIncrement"
        :inputId="id"
        :modelValue="modelValue"
        :classState="classState"
        @InputChanged="emitInputChanged"
        :suffix="suffix"
      >
      </BaseInputText>
    </span>

    <span 
      @mouseleave="stopLongPress"
      @click="next()"
      @mousedown="buttonMousedown('plus')"
      @mouseup="buttonMouseup()"
    >
      <BaseButtonIcon
        id="plus"
        :classState="renderClass('next')"
        :svgPath="require('@/lib/tui/assets/common/increment/plus_increment.svg')"
        style="margin-left: 0.4vw"
      >
      </BaseButtonIcon>
    </span>
  </div>
</template>

<script>
import BaseInputText from "./BaseInputText.vue";
import BaseButtonIcon from "./BaseButtonIcon.vue";

export default {
  name: "BaseNumberIncrement",
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  components: {
    BaseButtonIcon,
    BaseInputText,
  },
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  props: {
    id: [String, Number],
    modelValue: {
      type: [Number, Boolean],
      default: false
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 10,
    },
    longpress:{
      type:Boolean,
      default: false
    },
    target: String,
    suffix:{
      type: String,
      default:""
    },
    classState: String,
    incrementValue: {
      type: Number,
      default: 1
    }
  },
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  data() {
    return {
      timeInterval: null,
      isClickButton: false,
    };
  },
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  methods: {
    stopLongPress: function() {
      this.isClickButton = false;
      this.clearTimeInterval();
    },
    ////////////////////////////////////////////////////////////////////////
    buttonMousedown(flag) {
      if(!this.longpress) return;

      this.isClickButton = true;
      this.clearTimeInterval();
      this.timeInterval = setInterval(() => {
        this.buttonClick(flag);
      }, 250);
    },
    ////////////////////////////////////////////////////////////////////////
    buttonMouseup() {
      this.isClickButton = false;
      this.clearTimeInterval();
    },
    ////////////////////////////////////////////////////////////////////////
    clearTimeInterval() {
      if (this.timeInterval == null) return;
      clearInterval(this.timeInterval);
      this.timeInterval = null;
    },
    ////////////////////////////////////////////////////////////////////////
    buttonClick(flag) {
      if (flag === "plus")
        this.next();
      else if (flag === "minus")
        this.previous();
    },
    ////////////////////////////////////////////////////////////////////////
    next() {
      if (this.modelValue + this.incrementValue <= this.max)
        this.$emit("IncrementChanged", {
          value: this.modelValue + this.incrementValue,
          id: this.id,
          target: this.target
        });
    },
    ////////////////////////////////////////////////////////////////////////
    previous() {
      if (this.modelValue - this.incrementValue >= this.min)
        this.$emit("IncrementChanged", {
          value: this.modelValue - this.incrementValue,
          id: this.id,
          target: this.target
        });
    },
    ////////////////////////////////////////////////////////////////////////
    emitInputChanged: function (event) {
      if (!event || !Object.prototype.hasOwnProperty.call(event, "value")) return;

      if (event.value >= this.min && event.value <= this.max)
        this.$emit("IncrementChanged", {
          value: parseInt(event.value),
          id: this.id,
          target: this.target
        });
    },
    ////////////////////////////////////////////////////////////////////////
    renderClass: function(position) {
      if (!this.classState || (!this.modelValue && this.modelValue !== 0)) return;
      
      let newClass = "buttonIcon-trinnov no-background";
      let classArray = this.classState.split(" ");
      let sizes = ["small", "medium", "large", "extra-large"];

      for (let i = 0; i < classArray.length; i++) {
        if (classArray[i] === "disabled") {
          newClass += " disabled";
        }
        if (sizes.indexOf(classArray[i]) !== -1)
          newClass += " " + classArray[i];
      }

      if ((position === "prev" && this.modelValue <= this.min) || (position === "next" && this.modelValue >= this.max))
        newClass += " disabled";

      return newClass;
    }
  }
};
</script>

<style lang="scss">
  @import "@/lib/tui/scss/module/baseNumberIncrement.scss";
</style>

